// extracted by mini-css-extract-plugin
export default {"jumpToSectionButton":"SectionSelector_jumpToSectionButton__B4yGb","compact":"SectionSelector_compact__2AhEw"};